{
  "INBOX_MGMT": {
    "HEADER": "Entradas",
    "DESCRIPTION": "Un canal es el modo de comunicación que tu cliente elige para interactuar contigo. Una bandeja de entrada es donde administras interacciones para un canal específico. Puede incluir comunicaciones de diversas fuentes como correo electrónico, chat en vivo y redes sociales.",
    "LEARN_MORE": "Aprende más sobre las entradas",
    "RECONNECT": {
      "BUTTON": "Reconectar",
      "FACEBOOK": "La conexión con Facebook caducó o se revocó. Los mensajes enviados a la página no llegan a esta bandeja de entrada y las respuestas pueden fallar. Una persona que administre la página de Facebook debe hacer clic en Reconectar e iniciar sesión en Facebook.",
      "INSTAGRAM": "La conexión con Instagram caducó o se revocó. Los mensajes enviados a la cuenta no llegan a esta bandeja de entrada y las respuestas pueden fallar. Haz clic en Reconectar e inicia sesión con la misma cuenta de Instagram. Otra cuenta crea una nueva bandeja de entrada.",
      "GOOGLE": "La conexión con Google caducó o se revocó. Los correos nuevos no llegan a esta bandeja de entrada y las respuestas pueden fallar. Haz clic en Reconectar e inicia sesión en Google como {email}.",
      "MICROSOFT": "La conexión con Microsoft caducó o se revocó. Los correos nuevos no llegan a esta bandeja de entrada y las respuestas pueden fallar. Haz clic en Reconectar e inicia sesión en Microsoft como {email}.",
      "ALLEGRO": "La conexión con Allegro caducó o se revocó. Los mensajes de los compradores no llegan a esta bandeja de entrada y las respuestas pueden fallar. Haz clic en Reconectar e inicia sesión en Allegro como el vendedor {seller}. Otra cuenta de vendedor crea una nueva bandeja de entrada.",
      "IMAP_LOGIN": "El servidor de correo rechaza el inicio de sesión IMAP {login}. Los correos nuevos no llegan a esta bandeja. Comprueba el usuario y la contraseña de IMAP en la pestaña {tab} y guárdalos. Seguimos intentando iniciar sesión y la bandeja se recuperará en cuanto el inicio de sesión funcione.",
      "WHATSAPP": "La conexión con WhatsApp caducó o se revocó. Los archivos adjuntos de los clientes no llegan a esta bandeja de entrada y las respuestas pueden fallar. Haga clic en Reconectar, inicie sesión en Facebook y vuelva a seleccionar el número {phone}."
    },
    "LIST": {
      "404": "No hay entradas adjuntas a esta cuenta.",
      "RECONNECT_REQUIRED": "Es necesario volver a conectar"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Elegir canal",
        "BODY": "Elija el proveedor que desea integrar con el chat."
      },
      "INBOX": {
        "TITLE": "Crear bandeja de entrada",
        "BODY": "Autenticar tu cuenta y crear una bandeja de entrada."
      },
      "AGENT": {
        "TITLE": "Añadir agentes",
        "BODY": "Añadir agentes a la bandeja de entrada creada."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "¡Todo está listo!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Nombre de la bandeja de entrada",
        "PLACEHOLDER": "Introduzca el nombre de la bandeja de entrada (por ejemplo: Acme Inc)",
        "ERROR": "Por favor, introduzca un nombre de bandeja de entrada válido"
      },
      "WEBSITE_NAME": {
        "LABEL": "Nombre del sitio web",
        "PLACEHOLDER": "Introduzca el nombre de su sitio web (por ejemplo: Acme Inc)"
      },
      "FB": {
        "HELP": "PS: Al iniciar sesión, sólo tenemos acceso a los mensajes de tu Página. Nunca podremos acceder a tus mensajes privados.",
        "CHOOSE_PAGE": "Elegir página",
        "CHOOSE_PLACEHOLDER": "Seleccione una página de la lista",
        "INBOX_NAME": "Nombre de la bandeja de entrada",
        "ADD_NAME": "Añada un nombre para su bandeja de entrada",
        "PICK_NAME": "Elija un nombre para su bandeja de entrada",
        "PICK_A_VALUE": "Elija un valor",
        "CREATE_INBOX": "Crear bandeja de entrada"
      },
      "TWITTER": {
        "HELP": "Para añadir tu perfil de Twitter como un canal, necesitas autenticar tu perfil de Twitter haciendo clic en 'Iniciar sesión con Twitter' ",
        "ERROR_MESSAGE": "Se ha producido un error al conectar a Twitter, por favor inténtelo nuevamente",
        "TWEETS": {
          "ENABLE": "Crear conversaciones de los Tweets mencionados"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Canal del sitio web",
        "DESC": "Cree un canal para su sitio web y comience a apoyar a sus clientes a través de nuestro widget de sitio web.",
        "LOADING_MESSAGE": "Creando Canal de Soporte al Sitio Web",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar del canal"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL de Webhook",
          "PLACEHOLDER": "Por favor, introduzca su URL de Webhook",
          "ERROR": "Por favor, introduzca una URL válida"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Dominio del sitio web",
          "PLACEHOLDER": "Introduzca el dominio de su sitio web (por ejemplo: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Cabecera de bienvenida",
          "PLACEHOLDER": "¡Hola!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Bienvenido Tagline",
          "PLACEHOLDER": "Facilitamos la conexión con nosotros. Pídanos cualquier cosa o comparte tus comentarios."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Mensaje de bienvenida del canal",
          "PLACEHOLDER": "Acme Inc normalmente responde en unas pocas horas."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Habilitar bienvenida al canal",
          "HELP_TEXT": "Envía automáticamente un mensaje de saludo cuando se crea una nueva conversación.",
          "ENABLED": "Activado",
          "DISABLED": "Deshabilitado"
        },
        "REPLY_TIME": {
          "TITLE": "Establecer tiempo de respuesta",
          "IN_A_FEW_MINUTES": "En algunos minutos",
          "IN_A_FEW_HOURS": "En unas horas",
          "IN_A_DAY": "En un día",
          "HELP_TEXT": "Éste tiempo se mostrará en el widget del chat"
        },
        "WIDGET_COLOR": {
          "LABEL": "Color del widget",
          "PLACEHOLDER": "Actualizar el color del widget usado en el widget"
        },
        "SUBMIT_BUTTON": "Crear bandeja de entrada",
        "API": {
          "ERROR_MESSAGE": "No pudimos crear un canal del sitio web, por favor inténtalo de nuevo"
        }
      },
      "TWILIO": {
        "TITLE": "Canal Twilio SMS/WhatsApp",
        "DESC": "Integre Twilio y comience a apoyar a sus clientes mediante SMS o WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Cuenta SID",
          "PLACEHOLDER": "Introduce tu SID de cuenta de Twilio",
          "ERROR": "Este campo es obligatorio"
        },
        "API_KEY": {
          "USE_API_KEY": "Usar autenticación de Clave API",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Por favor ingrese su API Key SID",
          "ERROR": "Este campo es obligatorio"
        },
        "API_KEY_SECRET": {
          "LABEL": "Clave API secreta",
          "PLACEHOLDER": "Por favor ingrese su Clave API secreta",
          "ERROR": "Este campo es obligatorio"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Servicio de Mensajes SID",
          "PLACEHOLDER": "Por favor, introduzca su SID de Servicio de Mensajes de Twilio",
          "ERROR": "Este campo es obligatorio",
          "USE_MESSAGING_SERVICE": "Usar un servicio de mensajería de Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Tipo de canal",
          "ERROR": "Seleccione su tipo de canal"
        },
        "AUTH_TOKEN": {
          "LABEL": "Token de Auth",
          "PLACEHOLDER": "Por favor ingrese su Twilio Auth Token",
          "ERROR": "Este campo es obligatorio"
        },
        "CHANNEL_NAME": {
          "LABEL": "Nombre de la bandeja de entrada",
          "PLACEHOLDER": "Por favor, introduzca un nombre de bandeja de entrada",
          "ERROR": "Este campo es obligatorio"
        },
        "PHONE_NUMBER": {
          "LABEL": "Número telefónico",
          "PLACEHOLDER": "Por favor, introduzca el número de teléfono desde el que se enviará el mensaje.",
          "ERROR": "Por favor, proporcione un número de teléfono válido que comience con un signo `+` y no contenga espacios."
        },
        "API_CALLBACK": {
          "TITLE": "URL de devolución de llamada",
          "SUBTITLE": "Tiene que configurar la URL de devolución de llamada de mensaje en Twilio con la URL mencionada aquí."
        },
        "SUBMIT_BUTTON": "Crear Canal Twilio",
        "API": {
          "ERROR_MESSAGE": "No pudimos autenticar credenciales de Twilio, por favor inténtalo de nuevo"
        }
      },
      "SMS": {
        "TITLE": "Canal SMS",
        "DESC": "Comience a apoyar a sus clientes a través de SMS.",
        "PROVIDERS": {
          "LABEL": "Proveedor de API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Ancho de banda",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID de Cuenta",
            "PLACEHOLDER": "Introduzca su ID de cuenta de Bandwidth",
            "ERROR": "Este campo es obligatorio"
          },
          "API_KEY": {
            "LABEL": "Clave de API",
            "PLACEHOLDER": "Por favor, introduzca su clave API de Bandwith",
            "ERROR": "Este campo es obligatorio"
          },
          "API_SECRET": {
            "LABEL": "API secreta",
            "PLACEHOLDER": "Por favor ingrese su Bandwith API Secret",
            "ERROR": "Este campo es obligatorio"
          },
          "APPLICATION_ID": {
            "LABEL": "ID de la aplicación",
            "PLACEHOLDER": "Introduzca su ID de cuenta de Bandwidth",
            "ERROR": "Este campo es obligatorio"
          },
          "INBOX_NAME": {
            "LABEL": "Nombre de la bandeja de entrada",
            "PLACEHOLDER": "Por favor, introduzca un nombre de bandeja de entrada",
            "ERROR": "Este campo es obligatorio"
          },
          "PHONE_NUMBER": {
            "LABEL": "Número de teléfono",
            "PLACEHOLDER": "Por favor, introduzca el número de teléfono desde el que se enviará el mensaje.",
            "ERROR": "Por favor, proporcione un número de teléfono válido que comience con un signo `+` y no contenga espacios."
          },
          "SUBMIT_BUTTON": "Crear Canal de Bandwidth",
          "API": {
            "ERROR_MESSAGE": "No pudimos autenticar credenciales de Bandwidth, por favor inténtalo de nuevo"
          },
          "API_CALLBACK": {
            "TITLE": "URL de devolución de llamada",
            "SUBTITLE": "Tienes que configurar la URL de devolución de llamada de mensaje en Bandwidth con la URL mencionada aquí."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Nombre de la bandeja de entrada",
            "PLACEHOLDER": "Por favor, introduce un nombre de bandeja de entrada",
            "ERROR": "Este campo es obligatorio"
          },
          "PHONE_NUMBER": {
            "LABEL": "Número de teléfono",
            "PLACEHOLDER": "Por favor, introduce el número de teléfono desde el que se enviarán los mensajes.",
            "ERROR": "Por favor, proporciona un número de teléfono válido que comience con un signo `+`."
          },
          "SUBMIT_BUTTON": "Crear canal SMS Brana",
          "API": {
            "ERROR_MESSAGE": "No pudimos crear el canal SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Nombre de la bandeja de entrada",
            "PLACEHOLDER": "Por favor, introduce un nombre de bandeja de entrada",
            "ERROR": "Este campo es obligatorio"
          },
          "PHONE_NUMBER": {
            "LABEL": "Número de teléfono",
            "PLACEHOLDER": "Por favor, introduce el número de teléfono desde el que se enviarán los mensajes.",
            "ERROR": "Por favor, proporciona un número de teléfono válido que comience con un signo `+`."
          },
          "SUBMIT_BUTTON": "Crear canal DIDWW",
          "API": {
            "ERROR_MESSAGE": "No pudimos crear el canal DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "Proveedor de API",
          "WHATSAPP_CLOUD": "Nube de WhatsApp"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Tienes que configurar la URL del webhook y el token de verificación en el portal de desarrolladores de Facebook con los valores mostrados a continuación.",
          "WEBHOOK_URL": "URL de Webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "Token de verificación del Webhook"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Configuración rápida con Meta",
          "DESC": "Serás redirigido a Meta para iniciar sesión en tu cuenta de WhatsApp Business. Tener acceso de administrador ayudará a que la configuración sea rápida y sencilla.",
          "BENEFITS": {
            "EASY_SETUP": "No se requiere configuración manual",
            "SECURE_AUTH": "Autenticación segura basada en OAuth",
            "AUTO_CONFIG": "Configuración automática de webhook y número de teléfono"
          },
          "SUBMIT_BUTTON": "Conectar con WhatsApp Business",
          "AUTH_PROCESSING": "Autenticando con Meta",
          "WAITING_FOR_BUSINESS_INFO": "Completa la configuración del negocio en la ventana de Meta...",
          "PROCESSING": "Configurando tu cuenta de WhatsApp Business",
          "CANCELLED": "Se canceló el registro de WhatsApp",
          "WAITING_FOR_AUTH": "Esperando autenticación...",
          "INVALID_BUSINESS_DATA": "Se recibieron datos de negocio no válidos desde Facebook. Inténtalo de nuevo.",
          "SIGNUP_ERROR": "Se produjo un error en el registro",
          "SDK_LOAD_ERROR": "No se pudo cargar el SDK de Facebook. Inténtalo de nuevo.",
          "AUTH_NOT_COMPLETED": "La autenticación no se completó. Reinicia el proceso.",
          "SUCCESS_FALLBACK": "La cuenta de WhatsApp Business se configuró correctamente",
          "RECONNECTED": "El canal de WhatsApp se volvió a conectar correctamente"
        },
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal de WhatsApp"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Canal API",
        "DESC": "Integre con API channel y comienze a dar soporte a sus clientes.",
        "CHANNEL_NAME": {
          "LABEL": "Nombre del canal",
          "PLACEHOLDER": "Por favor, introduzca un nombre de canal",
          "ERROR": "Este campo es obligatorio"
        },
        "WEBHOOK_URL": {
          "LABEL": "URL de Webhook",
          "SUBTITLE": "Configure la URL donde recibirá las respuestas a los eventos.",
          "PLACEHOLDER": "URL de Webhook"
        },
        "SUBMIT_BUTTON": "Crear canal de API",
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal API"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Canal de Email",
        "DESC": "Integre su bandeja de entrada del email.",
        "CHANNEL_NAME": {
          "LABEL": "Nombre del canal",
          "PLACEHOLDER": "Por favor, introduzca un nombre de canal",
          "ERROR": "Este campo es obligatorio"
        },
        "EMAIL": {
          "LABEL": "E-mail",
          "SUBTITLE": "Email donde sus clientes le envían tickets de soporte",
          "PLACEHOLDER": "E-mail"
        },
        "SUBMIT_BUTTON": "Crear canal de email",
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal de email"
        },
        "FINISH_MESSAGE": "Empieze a reenviar su emails a la siguiente dirección de email."
      },
      "LINE_CHANNEL": {
        "TITLE": "Canal LÍNEA",
        "DESC": "Integre con el canal LINE y comience a apoyar a sus clientes.",
        "CHANNEL_NAME": {
          "LABEL": "Nombre del canal",
          "PLACEHOLDER": "Por favor, introduzca un nombre de canal",
          "ERROR": "Este campo es obligatorio"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID del canal LINE",
          "PLACEHOLDER": "ID del canal LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Secreto del canal LINE",
          "PLACEHOLDER": "Secreto del canal LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token de canal LINE",
          "PLACEHOLDER": "Token de canal LINE"
        },
        "SUBMIT_BUTTON": "Crear canal LINE",
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal LINE"
        },
        "API_CALLBACK": {
          "TITLE": "URL de devolución de llamada",
          "SUBTITLE": "Tiene que configurar la URL del webhook en la aplicación LINE con la URL mencionada aquí."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Canal de Telegram",
        "DESC": "Integre con el canal de Telegram y comience a apoyar a sus clientes.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Configura el token de bot que has obtenido de Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Crear canal de Telegram",
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal de telegram"
        }
      },
      "AUTH": {
        "TITLE": "Elija un canal",
        "DESC": "El chat soporta widgets de Live Chat, Facebook Messenger, WhatsApp, correos electrónicos, etc., como canales. Si quieres construir un canal personalizado, puedes crearlo usando el canal API. Para empezar, elige uno de los canales a continuación."
      },
      "AGENTS": {
        "TITLE": "Agentes",
        "DESC": "Aquí puede agregar agentes para administrar su recién creada bandeja de entrada. Sólo estos agentes seleccionados tendrán acceso a su bandeja de entrada. Los agentes que no forman parte de esta bandeja de entrada no podrán ver o responder a los mensajes de esta bandeja de entrada cuando inicien sesión. <br> <b>PS:</b> Como administrador, si necesita acceso a todas las bandejas, debes añadirte como agente a todas las bandejas de entrada que crees.",
        "VALIDATION_ERROR": "Añade al menos un agente a tu nueva bandeja de entrada",
        "PICK_AGENTS": "Elegir agentes para la bandeja de entrada"
      },
      "DETAILS": {
        "TITLE": "Detalles de la bandeja de entrada",
        "DESC": "En el menú desplegable de abajo, selecciona la página de Facebook que quieres conectar al chat. También puede dar un nombre personalizado a su bandeja de entrada para una mejor identificación."
      },
      "FINISH": {
        "TITLE": "¡Se ha clavado!",
        "DESC": "Has terminado de integrar correctamente tu página de Facebook con el chat. La próxima vez que un cliente envíe un mensaje a tu Página, la conversación aparecerá automáticamente en tu bandeja de entrada.<br>También le estamos proporcionando un script de widget que puede agregar fácilmente a su sitio web. Una vez que esto está en vivo en tu sitio web, los clientes pueden enviarle mensajes directamente desde su sitio web sin la ayuda de ninguna herramienta externa y la conversación aparecerá aquí, en el chat.<br>¿Genial, eh? Bueno, estamos seguros de que intentaremos ser :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Selecciona tu proveedor de correo",
        "DESCRIPTION": "Seleccione un proveedor de correo electrónico de la siguiente lista. Si no ve a su proveedor de correo en la lista, puede seleccionar la opción de otro proveedor y proporcionar las credenciales IMAP y SMTP."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Haga clic en el botón Iniciar sesión con Microsoft para empezar. Serás redirigido a la página de inicio de sesión de correo electrónico. Una vez que aceptes los permisos solicitados, serás redirigido al paso de creación de la bandeja de entrada.",
        "EMAIL_PLACEHOLDER": "Introduzca la dirección de correo",
        "SIGN_IN": "Iniciar sesión con Microsoft",
        "ERROR_MESSAGE": "Hubo un error al conectarse a Microsoft, por favor inténtalo de nuevo"
      },
      "GOOGLE": {
        "TITLE": "Correo de Google",
        "DESCRIPTION": "Haga clic en el botón Iniciar sesión con Google para empezar. Serás redirigido a la página de inicio de sesión de correo electrónico. Una vez que aceptes los permisos solicitados, serás redirigido al paso de creación de la bandeja de entrada.",
        "SIGN_IN": "Iniciar sesión con Google",
        "EMAIL_PLACEHOLDER": "Introduzca la dirección de correo",
        "ERROR_MESSAGE": "Se ha producido un error al conectar a Google, por favor inténtelo nuevamente"
      },
      "INTERNAL_NAME": {
        "LABEL": "Nombre interno",
        "PLACEHOLDER": "Nombra la bandeja de entrada como aparece en este panel",
        "ERROR": "Por favor, introduce un nombre interno único"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continuar con Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Conecta tu perfil de Instagram",
        "HELP": "Para añadir tu perfil de Instagram como canal, debes autenticar tu perfil de Instagram haciendo clic en \"Continuar con Instagram\" ",
        "ERROR_MESSAGE": "Hubo un error al conectar con Instagram, por favor inténtalo de nuevo",
        "ERROR_AUTH": "Hubo un error al conectar con Instagram, por favor inténtalo de nuevo",
        "NEW_INBOX_SUGGESTION": "Esta cuenta de Instagram estaba previamente vinculada a una bandeja de entrada diferente y ahora ha sido migrada aquí. Todos los nuevos mensajes aparecerán aquí. La bandeja de entrada antigua ya no podrá enviar ni recibir mensajes para esta cuenta.",
        "DUPLICATE_INBOX_BANNER": "Esta cuenta de Instagram fue migrada a la nueva bandeja de entrada del canal de Instagram. Ya no podrás enviar/recibir mensajes de Instagram desde esta bandeja de entrada."
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Canal Salesforce",
        "DESC": "Integra con el canal Salesforce y comienza a dar soporte a tus clientes.",
        "CHANNEL_NAME": {
          "LABEL": "Nombre del canal",
          "PLACEHOLDER": "Por favor, introduce un nombre de canal",
          "ERROR": "Este campo es obligatorio"
        },
        "API_BASE_URL": {
          "LABEL": "URL de la API de Salesforce",
          "SUBTITLE": "Configura la URL base para tu instancia de Salesforce.",
          "PLACEHOLDER": "URL Salesforce API",
          "ERROR": "Este campo es obligatorio"
        },
        "KEY_ID": {
          "LABEL": "Key ID",
          "SUBTITLE": "Key ID para tu canal Salesforce.",
          "PLACEHOLDER": "KEY ID",
          "ERROR": "Este campo es obligatorio"
        },
        "SECRET": {
          "LABEL": "Secret",
          "SUBTITLE": "Secret para tu canal Salesforce.",
          "PLACEHOLDER": "*****",
          "ERROR": "Este campo es obligatorio"
        },
        "SUBMIT_BUTTON": "Crear canal Salesforce",
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal Salesforce"
        },
        "API_CALLBACK": {
          "TITLE": "URL del Webhook",
          "SUBTITLE": "Tienes que configurar la URL del webhook en Salesforce con la URL mencionada aquí."
        },
        "BEARER_TOKEN": {
          "TITLE": "Token Bearer",
          "SUBTITLE": "Usa este token bearer para la autenticación al configurar el webhook en Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Sobrescribir remitente del correo",
          "SUBTITLE": "Si se configura, esta dirección de correo se usará como remitente para todos los correos salientes en lugar del correo de origen de la conversación.",
          "PLACEHOLDER": "p. ej. soporte{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Canal de Allegro",
        "DESC": "Conecte una cuenta de vendedor de Allegro y responda a sus mensajes desde el Centro de Contacto.",
        "CHANNEL_NAME": {
          "LABEL": "Nombre de la bandeja de entrada",
          "SUBTITLE": "El nombre que los agentes ven para esta bandeja de entrada.",
          "PLACEHOLDER": "Introduzca un nombre de bandeja de entrada",
          "ERROR": "Este campo es obligatorio"
        },
        "SUBMIT_BUTTON": "Iniciar sesión con Allegro",
        "API": {
          "ERROR_MESSAGE": "Se produjo un error al conectar con Allegro, por favor inténtelo de nuevo"
        },
        "SELLER_LOGIN": {
          "TITLE": "Inicio de sesión de Allegro",
          "SUBTITLE": "La cuenta de vendedor cuyos mensajes lee y responde esta bandeja de entrada."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Canal de Kaufland",
        "DESC": "Responda a los mensajes de tickets que los compradores le envían en el marketplace de Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Nombre del canal",
          "PLACEHOLDER": "Por favor, introduzca un nombre de canal",
          "ERROR": "Este campo es obligatorio"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "La Client Key (clave de cliente) de 32 caracteres de la página de ajustes de API de su cuenta de vendedor de Kaufland.",
          "PLACEHOLDER": "Clave de 32 caracteres",
          "ERROR": "Introduzca la Client Key de 32 caracteres"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "La Secret Key (clave secreta) de 64 caracteres que pertenece a la Client Key. Kaufland la muestra una sola vez y nunca la envía de vuelta a esta página.",
          "PLACEHOLDER": "Clave de 64 caracteres",
          "ERROR": "Introduzca la Secret Key de 64 caracteres"
        },
        "SUBMIT_BUTTON": "Crear canal de Kaufland",
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal de Kaufland"
        },
        "DISCONNECTED": {
          "TITLE": "Desconectado",
          "MESSAGE": "Kaufland rechazó estas claves de API. Introduzca de nuevo la client key y la secret key para volver a conectar esta bandeja de entrada."
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Llamadas telefónicas",
        "DESC": "Configura qué llamadas telefónicas se mostrarán en esta bandeja de entrada.",
        "NAME": {
          "LABEL": "Nombre de la bandeja de entrada",
          "SUBTITLE": "Elige un nombre fácilmente identificable."
        },
        "PHONE_NUMBER": {
          "LABEL": "Número de teléfono",
          "SUBTITLE": "Introduce los números de teléfono que pertenecen a esta bandeja de entrada, puedes añadir más números más tarde.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Crear bandeja de entrada de llamadas",
        "API": {
          "ERROR_MESSAGE": "No pudimos crear la bandeja de entrada"
        }
      }
    },
    "DETAILS": {
      "LOADING_FB": "Autenticándote con Facebook...",
      "ERROR_FB_LOADING": "Error al cargar Facebook SDK. Deshabilite cualquier bloqueador de anuncios e inténtelo de nuevo desde un navegador diferente.",
      "ERROR_FB_AUTH": "Algo salió mal, Por favor actualiza la página...",
      "ERROR_FB_UNAUTHORIZED": "No estás autorizado a realizar esta acción. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Asegúrate de tener acceso a la página de Facebook con control completo. Puedes leer más sobre los roles de Facebook <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "No pudimos crear la bandeja de entrada. Inténtalo de nuevo.",
      "CREATING_CHANNEL": "Creando tu bandeja de entrada...",
      "TITLE": "Configurar detalles de la Bandeja de Entrada",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Añadir agentes",
      "ADD_AGENTS": "Añadiendo agentes a tu bandeja de entrada..."
    },
    "FINISH": {
      "TITLE": "¡Tu bandeja de entrada está lista!",
      "MESSAGE": "Ahora puedes colaborar con tus clientes a través de tu nuevo canal. Feliz soporte",
      "BUTTON_TEXT": "Llévame allí",
      "MORE_SETTINGS": "Más ajustes",
      "WEBSITE_SUCCESS": "Has terminado de crear un canal del sitio web. Copia el código que se muestra a continuación y pégalo en tu sitio web. La próxima vez que un cliente use el chat en vivo, la conversación aparecerá automáticamente en su bandeja de entrada."
    },
    "REAUTH": "Reautorizar",
    "VIEW": "Ver",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Configuración de bandeja de entrada actualizada correctamente",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Auto-asignación actualizada correctamente",
        "ERROR_MESSAGE": "No pudimos actualizar la configuración de la bandeja de entrada. Por favor, inténtalo de nuevo más tarde."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Activado",
        "DISABLED": "Deshabilitado"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Activado",
        "DISABLED": "Deshabilitado"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Nombre del remitente",
        "SUB_TEXT": "Seleccione el nombre que se muestra al cliente cuando reciba correos electrónicos de sus agentes.",
        "FOR_EG": "Por ejemplo:",
        "FRIENDLY": {
          "TITLE": "Amigable",
          "FROM": "De",
          "SUBTITLE": "Añada el nombre del agente que envió la respuesta en el nombre del remitente para que sea amistoso."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesional",
          "SUBTITLE": "Utilice sólo el nombre del negocio configurado como nombre del remitente en el encabezado del correo electrónico."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configura el nombre de tu negocio",
          "PLACEHOLDER": "Introduce el nombre de tu negocio",
          "SAVE_BUTTON_TEXT": "Guardar"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Activado",
        "DISABLED": "Deshabilitado"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Activado",
        "DISABLED": "Deshabilitado"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Ninguno"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Activado",
        "DISABLED": "Deshabilitado"
      },
      "ENABLE_HMAC": {
        "LABEL": "Habilitar"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Activado",
        "DISABLED": "Deshabilitado"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Activado",
        "DISABLED": "Deshabilitado"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Habilitado",
        "DISABLED": "Deshabilitado"
      },
      "SHOW_WELCOME_SCREEN": {
        "ENABLED": "Habilitado",
        "DISABLED": "Deshabilitado"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Habilitar sincronización de correos entrantes"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Habilitar dominio de correo personalizado (servicio de pago)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Habilitar procesamiento de comentarios de Facebook"
      },
      "SIGNATURE": {
        "TITLE": "Firma HTML",
        "SUB_TEXT": "Esta firma se añadirá al pie de cada mensaje enviado desde esta bandeja de entrada.",
        "HTML_CONTENT": "Código HTML",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} se reemplazará por el nombre del agente.\\n{'{{'}email{'}}'} se reemplazará por la dirección de correo del agente que envió el correo.\\n{'{{'}position{'}}'} se reemplazará por el cargo del agente.\\n{'{{'}custom_line{'}}'} se reemplazará por la línea personalizada del agente.\\n{'{{'}email_signature_picture{'}}'} se reemplazará por la URL de la imagen de firma de correo del agente (no una etiqueta de imagen) — úsala como fuente de imagen (el atributo src de una etiqueta img).",
        "PREVIEW": "Vista previa"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Firmas por país",
        "SUB_TEXT": "Una respuesta recibe la firma del país del comprador.",
        "HELP": "Una respuesta se firma según el país de su conversación: la tienda de Kaufland, el mercado del pedido de Allegro o, si no, el idioma en el que escribe el comprador. Cuando el país es desconocido o no tiene firma aquí, se usa la firma HTML de arriba. Los marketplaces prohíben los enlaces a tu sitio web y los datos de contacto, así que limítate a un saludo y {'{{'}name{'}}'}.",
        "EMPTY": "Aún no tienes firmas por país, así que las respuestas usan la firma HTML de arriba.",
        "COUNTRY": "Selecciona un país",
        "ADD": "Añadir firma por país",
        "REMOVE": "Eliminar"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Prefijo de marcación del número de teléfono",
        "PLACEHOLDER": "Introduce el prefijo para el enrutamiento correcto de llamadas (p. ej., *99)",
        "HELP_TEXT": "Este prefijo se antepondrá automáticamente a los números de teléfono de los contactos al marcar desde esta bandeja de entrada."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Texto del botón «resolver más tarde»",
        "PLACEHOLDER": "p. ej. Resolveremos este tema por correo electrónico. Ahora quiero preguntar sobre otra cosa.",
        "HELP_TEXT": "Texto del botón del widget con el que el visitante abandona el tema actual y pregunta sobre otra cosa. Si lo deja vacío, se usará el texto predeterminado en el idioma del visitante."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Posponer automáticamente las llamadas perdidas durante X minutos",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Pospone automáticamente las llamadas perdidas durante el número de minutos especificado. Deja vacío o 0 para deshabilitar."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Resolver una llamada perdida tras X devoluciones de llamada fallidas",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Cuando una llamada perdida se ha devuelto X veces sin que el cliente conteste, se resuelve automáticamente y se añade una nota privada. Deja vacío o 0 para deshabilitar."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Sugerencias de preguntas",
        "SUB_TEXT": "Configura preguntas predefinidas que los clientes pueden usar para interactuar con tus agentes.",
        "QUESTIONS_LABEL": "Preguntas",
        "ADD_QUESTION": "Añadir pregunta",
        "QUESTION": "Pregunta",
        "REMOVE": "Eliminar",
        "QUESTION_TEXT": "Texto mostrado en la burbuja.",
        "QUESTION_TEXT_PLACEHOLDER": "Obligatorio",
        "QUESTION_PAYLOAD": "Texto enviado al hacer clic.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Opcional",
        "SAVE": "Guardar",
        "NO_BOT_MESSAGE": "Para generar sugerencias adicionales de IA, por favor conecta un bot.",
        "BOT_CONNECTED_MESSAGE": "Las sugerencias de preguntas IA del bot pueden activarse en su",
        "BOT_SETTINGS_LINK": "configuración"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Correos electrónicos alternativos",
        "SUB_TEXT": "Direcciones adicionales que esta bandeja de entrada debe tratar como propias al recibir correo reenviado.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Agregar",
        "REMOVE": "Eliminar",
        "EMPTY": "No hay correos electrónicos alternativos configurados.",
        "HELP_TEXT": "Cuando llegue un correo electrónico con una de estas direcciones como destinatario, las respuestas se enviarán con la misma dirección como remitente. Asegúrate de que tu servidor SMTP saliente permita el envío desde estas direcciones.",
        "SIGNATURE_LABEL": "Firma",
        "PRIMARY_SIGNATURE": "Principal (predeterminada)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Firmas adicionales",
        "SUB_TEXT": "Define firmas adicionales aquí y luego asígnalas a los correos alternativos de abajo.",
        "OPTION": "Firma {number}",
        "ADD": "Añadir firma",
        "REMOVE": "Eliminar",
        "HELP_TEXT": "Cuando se envía una respuesta desde un correo alternativo, se usa la firma asignada en lugar de la firma de la bandeja de entrada. Los correos alternativos que se dejan en «Principal (predeterminada)» vuelven a la firma de la bandeja de entrada."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Eliminar",
      "AVATAR_DELETE_BUTTON_TEXT": "Eliminar avatar",
      "CONFIRM": {
        "TITLE": "Confirmar eliminación",
        "MESSAGE": "¿Está seguro de eliminar ",
        "PLACE_HOLDER": "Por favor, escriba {inboxName} para confirmar",
        "YES": "Sí, eliminar ",
        "NO": "No, mantenerlo "
      },
      "API": {
        "SUCCESS_MESSAGE": "Bandeja de entrada eliminada correctamente",
        "ERROR_MESSAGE": "No se pudo eliminar la bandeja de entrada. Inténtalo de nuevo más tarde.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar de bandeja de entrada eliminado correctamente",
        "AVATAR_ERROR_MESSAGE": "No se pudo eliminar el avatar de la bandeja de entrada. Inténtalo de nuevo más tarde.",
        "MARKED_FOR_DELETION_MESSAGE": "Bandeja de entrada marcada para eliminación",
        "RESTORE_SUCCESS_MESSAGE": "Bandeja de entrada restaurada correctamente",
        "RESTORE_ERROR_MESSAGE": "No se pudo restaurar la bandeja de entrada. Por favor, inténtalo más tarde."
      },
      "DELETE_REQUESTED_TOOLTIP": "Esta bandeja de entrada está marcada para eliminación",
      "RESTORE_BUTTON_TEXT": "Restaurar"
    },
    "TABS": {
      "SETTINGS": "Ajustes",
      "COLLABORATORS": "Colaboradores",
      "CONFIGURATION": "Configuración",
      "CAMPAIGN": "Campañas",
      "PRE_CHAT_FORM": "Pre-formulario de chat",
      "BUSINESS_HOURS": "Horarios",
      "WIDGET_BUILDER": "Constructor de Widget",
      "BOT_CONFIGURATION": "Configuración del bot",
      "AUTOMATIC_PRIORITY": "Prioridad automática",
      "AUTOMATIC_LABELING": "Etiquetado automático",
      "SLA": "SLA"
    },
    "SETTINGS": "Ajustes",
    "FEATURES": {
      "LABEL": "Características",
      "DISPLAY_FILE_PICKER": "Mostrar el selector de archivos en el widget",
      "DISPLAY_EMOJI_PICKER": "Mostrar el selector de emoji en el widget",
      "ALLOW_END_CONVERSATION": "Permitir a los usuarios finalizar conversaciones desde el widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Mostrar el botón 'Iniciar una nueva conversación' en la cabecera del widget",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Ocultar el campo de entrada cuando se muestre el botón de iniciar una nueva conversación",
      "SHOW_HANDOFF_BUTTON": "Mostrar el botón 'Transferir a un operador' en la cabecera del widget",
      "USE_INBOX_AVATAR_FOR_BOT": "Usar nombre de bandeja de entrada y avatar para el bot",
      "ALLOW_OFFLINE_REPLY": "Permitir a los agentes enviar mensajes cuando el contacto esté desconectado y la continuidad por correo no esté disponible",
      "AUTO_CLOSE_OLD": "Marcar todas las llamadas pasadas del mismo número como resueltas después de resolver una",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Asignar automáticamente las llamadas perdidas al hacer una llamada saliente"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Script de Messenger",
      "MESSENGER_SUB_HEAD": "Coloca este botón dentro de tu etiqueta cuerpo",
      "INBOX_AGENTS": "Agentes",
      "INBOX_AGENTS_SUB_TEXT": "Añadir o quitar agentes de esta bandeja de entrada",
      "AGENT_ASSIGNMENT": "Asignación de conversación",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Actualizar configuración de la asignación de conversación",
      "UPDATE": "Actualizar",
      "ENABLE_EMAIL_COLLECT_BOX": "Activar caja de recolección de correo electrónico",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Activar o desactivar la caja de recolección de correo electrónico",
      "AUTO_ASSIGNMENT": "Activar asignación automática",
      "ENABLE_CSAT": "Habilitar Encuesta de Satisfacción",
      "SENDER_NAME_SECTION": "Habilitar nombre del agente en el correo electrónico",
      "ENABLE_CSAT_SUB_TEXT": "Habilitar/deshabilitar encuesta CSAT(satisfacción del cliente) después de resolver una conversación",
      "SENDER_NAME_SECTION_TEXT": "Habilitar/Deshabilitar mostrando el nombre del agente en el correo electrónico, si está deshabilitado, mostrará el nombre del negocio",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Habilitar continuidad de conversación por correo electrónico",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Las conversaciones continuarán por correo electrónico si la dirección de correo electrónico de contacto está disponible.",
      "RESPOND_FROM_EMAIL": "Responder desde correo electrónico",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Los correos al cliente (tanto las respuestas como las transcripciones de conversaciones) se envían usando la configuración SMTP de la bandeja de entrada de correo seleccionada, desde la dirección seleccionada (la propia dirección de la bandeja de entrada o uno de sus alias), y las respuestas del cliente llegan a través de su dirección IMAP.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Las transcripciones de conversaciones se envían usando la configuración SMTP de la bandeja de entrada de correo seleccionada, desde la dirección seleccionada (la propia dirección de la bandeja de entrada o uno de sus alias), y las respuestas llegan a través de su dirección IMAP.",
      "LOCK_TO_SINGLE_CONVERSATION": "Bloquear a una sola conversación",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Activar o desactivar múltiples conversaciones para el mismo contacto en esta bandeja de entrada",
      "INBOX_UPDATE_TITLE": "Ajustes de la Bandeja de Entrada",
      "INBOX_UPDATE_SUB_TEXT": "Actualizar la configuración de tu bandeja de entrada",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Activar o desactivar la asignación automática de nuevas conversaciones a los agentes añadidos a esta bandeja de entrada.",
      "HMAC_VERIFICATION": "Validación de identidad de usuario",
      "HMAC_DESCRIPTION": "Para validar la identidad del usuario, puede pasar un `identifier_hash` para cada usuario. Puedes generar un hash HMAC sha256 usando el `identifier` con la clave que se muestra aquí.",
      "HMAC_LINK_TO_DOCS": "Puedes leer más aquí.",
      "HMAC_MANDATORY_VERIFICATION": "Forzar validación de identidad de usuario",
      "HMAC_MANDATORY_DESCRIPTION": "Si está activado, las peticiones que no tengan el `identifier_hash` serán rechazadas.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Forzar una nueva conversación en cada carga del widget",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Si está activado, abrir el widget en una pestaña o ventana nueva inicia una nueva conversación.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Olvidar el contacto al iniciar una nueva conversación",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Si está desactivado, una nueva conversación iniciada desde el widget mantiene el contacto anterior.",
      "INBOX_IDENTIFIER": "Identificador de bandeja de entrada",
      "INBOX_IDENTIFIER_SUB_TEXT": "Usa el token `inbox_identifier` que se muestra aquí para autenticar tus clientes API.",
      "FORWARD_EMAIL_TITLE": "Reenviar al correo",
      "FORWARD_EMAIL_SUB_TEXT": "Empieze a reenviar su emails a la siguiente dirección de email.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Permitir mensajes después de la conversación resuelta",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Permitir a los usuarios finales enviar mensajes incluso después de que la conversación sea resuelta.",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Actualizar configuración de Formulario de Chat",
      "INBOX_TEAMS": "Equipos",
      "INBOX_COOPERATORS": "Colaboradores",
      "SELECT_PLACEHOLDER": "Seleccionar",
      "AGENTS_OR_TEAMS_INFO": "Puedes asignar agentes o equipos, no ambos simultáneamente.",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Habilitar CSAT en cada mensaje",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Habilitar/Deshabilitar la opción de encuesta CSAT para cada mensaje enviado por los agentes",
      "SHOW_WELCOME_SCREEN": "Mostrar pantalla de bienvenida",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Mostrar la pantalla de bienvenida cuando se abra el widget. Si está deshabilitado, el widget irá directamente a la vista de la conversación.",
      "AUTO_CLOSE_PENDING": "Resolver automáticamente los chats con IA después de (horas)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Resolver automáticamente los chats con IA después de X horas de inactividad.",
      "HMAC_ROTATE": {
        "BUTTON": "Rotar clave",
        "TITLE": "¿Rotar la clave secreta?",
        "WARNING": "La clave actual queda revocada en el instante en que la rota.",
        "WARNING_DETAIL": "No hay periodo de solapamiento y no se puede restaurar.",
        "IMPACT": "Sus servidores deben firmar a los usuarios con la nueva clave. Quien siga firmado con la anterior no supera la verificación. Si la validación de identidad es obligatoria, no podrá iniciar una conversación.",
        "CONFIRM": "Rotar clave",
        "CANCEL": "Cancelar",
        "SUCCESS": "Clave secreta rotada correctamente",
        "ERROR": "No se pudo rotar la clave secreta, inténtalo de nuevo"
      },
      "EMAIL_FETCHING_ENABLED_TITLE": "Sincronización de correo",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Habilitar la sincronización automática y descarga de correos entrantes desde esta bandeja de entrada",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Dominio de correo personalizado",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Habilitar para usar un dominio de correo personalizado para los correos salientes",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Puedes leer más aquí.",
      "FACEBOOK_COMMENTS_TITLE": "Comentarios de Facebook",
      "WIDGET_STATUS_LABEL": "Estado del widget",
      "WIDGET_STATUS_ENABLED": "Habilitado",
      "WIDGET_STATUS_BUSINESS_HOURS": "Habilitado durante el horario laboral",
      "WIDGET_STATUS_DISABLED": "Deshabilitado",
      "WIDGET_STATUS_HELP_TEXT": "Controla cuándo se muestra el widget a los visitantes en tu sitio web",
      "EXPLICIT_CSAT_LOCALE": "Idioma de la encuesta CSAT y del correo",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Elige el idioma para todos los correos a clientes incluyendo encuestas CSAT, transcripciones de conversaciones y notificaciones por correo",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Heredar de la cuenta",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Conexión de WhatsApp",
        "SUBTITLE": "Cómo está conectada esta bandeja a WhatsApp.",
        "PROVIDER": "Proveedor",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Conectado mediante el registro integrado de Meta",
        "STATUS": "Estado",
        "CONNECTED": "Conectado",
        "RECONNECT_HINT": "Haz clic en Reconectar en el aviso de arriba.",
        "PHONE_NUMBER": "Número de teléfono",
        "BUSINESS_ACCOUNT": "ID de la cuenta de WhatsApp Business",
        "OPEN_MANAGER": "Abrir en WhatsApp Manager",
        "PHONE_NUMBER_ID": "ID del número de teléfono",
        "TEMPLATES": "Plantillas de mensajes",
        "TEMPLATES_COUNT": "{approved} de {total} aprobadas",
        "TEMPLATES_SYNCED": "Última sincronización: {date}",
        "TEMPLATES_NOT_SYNCED": "Aún no sincronizadas",
        "MANAGE_TEMPLATES": "Gestionar plantillas"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Centro de ayuda",
      "PLACEHOLDER": "Seleccione Centro de Ayuda",
      "SELECT_PLACEHOLDER": "Seleccione Centro de Ayuda",
      "REMOVE": "Eliminar Centro de Ayuda",
      "SUB_TEXT": "Adjuntar un Centro de Ayuda con la bandeja de entrada"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Límite de asignación automática",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Por favor ingrese un valor mayor a 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limite la cantidad máxima de conversaciones de esta bandeja de entrada que se pueden asignar automáticamente a un agente"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Reautorizar",
      "SUBTITLE": "Su conexión de Facebook expiró, por favor reconecte si página de Facebook para continuar con el servicio",
      "MESSAGE_SUCCESS": "Reconección satisfactoria",
      "MESSAGE_ERROR": "Se presento un error, por favor inténtelo de nuevo"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Los formularios de Pre Chat le permiten capturar la información del usuario antes de que comiencen la conversación con usted.",
      "SET_FIELDS": "Campos del formulario del chat",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Campos",
        "LABEL": "Etiqueta",
        "PLACE_HOLDER": "Marca de posición",
        "KEY": "Llave",
        "TYPE": "Tipo",
        "REQUIRED": "Requerido"
      },
      "ENABLE": {
        "LABEL": "Activar formulario de pre-chat",
        "OPTIONS": {
          "ENABLED": "Si",
          "DISABLED": "No"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Mensaje de prechat",
        "PLACEHOLDER": "Este mensaje sería visible para los usuarios junto con el formulario"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Los visitantes deben proporcionar su nombre y dirección de correo electrónico antes de iniciar el chat"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Establecer su disponibilidad",
      "SUBTITLE": "Establezca su disponibilidad en su widget de livechat",
      "WEEKLY_TITLE": "Establecer sus horas semanales",
      "TIMEZONE_LABEL": "Seleccione la zona horaria",
      "UPDATE": "Actualice las horas de atención",
      "TOGGLE_AVAILABILITY": "Habilite la disponibilidad de atención para esta bandeja de entrada",
      "UNAVAILABLE_MESSAGE_LABEL": "Mensaje no disponible para visitantes",
      "TOGGLE_HELP": "Al habilitar el horario de atención se mostraran las horas disponibles en el \"widget\" del chat en vivo si todos los agentes están fuera de línea. Fuera de las horas disponibles los visitantes pueden ser notificado con un mensaje y una forma PreChat.",
      "DAY": {
        "ENABLE": "Activar la disponibilidad para este día",
        "UNAVAILABLE": "No disponible",
        "HOURS": "horas",
        "VALIDATION_ERROR": "La hora de inicio debe ser antes de la hora de cierre.",
        "CHOOSE": "Elegir"
      },
      "ALL_DAY": "Todo el día",
      "SAVE_TO_ALL": "Guardar en todas las bandejas de entrada",
      "SAVE_TO_ALL_TITLE": "Copiar horario laboral",
      "SAVE_TO_ALL_CONFIRM": "La configuración de este formulario (interruptor de disponibilidad, mensaje fuera de oficina, zona horaria y horario laboral) se copiará a todas las demás bandejas de entrada excepto las de correo y teléfono. ¿Estás seguro de que deseas continuar?",
      "SAVE_TO_ALL_CANCEL": "Cancelar",
      "SAVE_TO_ALL_YES": "Sí, copiar a todos",
      "SAVE_TO_ALL_SUCCESS": "Horario laboral copiado correctamente a todas las demás bandejas de entrada",
      "SAVE_TO_ALL_ERROR": "Error al copiar el horario laboral a otras bandejas de entrada"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Configura los detalles de IMAP",
      "NOTE_TEXT": "Para habilitar SMTP, por favor configure IMAP.",
      "UPDATE": "Actualizar ajustes IMAP",
      "TOGGLE_AVAILABILITY": "Habilitar configuración IMAP para esta bandeja de entrada",
      "TOGGLE_HELP": "Habilitar IMAP ayudará al usuario a recibir correo electrónico",
      "EDIT": {
        "SUCCESS_MESSAGE": "Configuración IMAP actualizada correctamente",
        "ERROR_MESSAGE": "No se puede actualizar la configuración IMAP"
      },
      "ADDRESS": {
        "LABEL": "Dirección",
        "PLACE_HOLDER": "Dirección (Ej: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Puerto",
        "PLACE_HOLDER": "Puerto"
      },
      "LOGIN": {
        "LABEL": "Iniciar sesión",
        "PLACE_HOLDER": "Iniciar sesión"
      },
      "PASSWORD": {
        "LABEL": "Contraseña",
        "PLACE_HOLDER": "Contraseña"
      },
      "ENABLE_SSL": "Activar SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reautorizar su cuenta MICROSOFT"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Configura tus detalles de SMTP",
      "UPDATE": "Actualizar ajustes SMTP",
      "TOGGLE_AVAILABILITY": "Habilitar configuración SMTP para esta bandeja de entrada",
      "TOGGLE_HELP": "Habilitar SMTP ayudará al usuario a enviar correo electrónico",
      "EDIT": {
        "SUCCESS_MESSAGE": "Configuración SMTP actualizada correctamente",
        "ERROR_MESSAGE": "No se puede actualizar la configuración SMTP"
      },
      "ADDRESS": {
        "LABEL": "Dirección",
        "PLACE_HOLDER": "Dirección (Ej: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Puerto",
        "PLACE_HOLDER": "Puerto"
      },
      "LOGIN": {
        "LABEL": "Iniciar sesión",
        "PLACE_HOLDER": "Iniciar sesión"
      },
      "PASSWORD": {
        "LABEL": "Contraseña",
        "PLACE_HOLDER": "Contraseña"
      },
      "DOMAIN": {
        "LABEL": "Dominio",
        "PLACE_HOLDER": "Dominio"
      },
      "ENCRYPTION": "Cifrado",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Abrir modo de verificación SSL",
      "AUTH_MECHANISM": "Autenticación"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Entregabilidad del correo (DNS)",
      "SUB_TITLE": "Revisamos los registros SPF, DKIM, DMARC y MX de {domain} cada día laborable. Cuando algo hace que los servidores receptores rechacen o envíen a spam sus respuestas, los administradores reciben un correo con la solución.",
      "RUN": "Ejecutar revisión",
      "RUN_SUCCESS": "Revisión de DNS finalizada",
      "RUN_ERROR": "No se pudo ejecutar la revisión de DNS, inténtelo de nuevo",
      "NOT_CHECKED": "Aún no se ha revisado.",
      "CHECKED_AT": "Última revisión: {time}.",
      "DNS_UNAVAILABLE": "En la última revisión, los servidores de nombres del dominio no respondieron. El resultado de abajo es de la revisión anterior.",
      "SENDER": {
        "SMTP": "Las respuestas se envían a través de {host}.",
        "PLATFORM": "Las respuestas se envían a través de nuestros servidores de correo."
      },
      "STATUS": {
        "OK": "Todos los registros están en orden",
        "WARNING": "Algunos registros se pueden mejorar",
        "ERROR": "Es posible que las respuestas no lleguen a sus destinatarios",
        "UNKNOWN": "Desconocido"
      },
      "SEVERITY": {
        "ERROR": "Problema",
        "WARNING": "Advertencia"
      },
      "FIX": "Se soluciona con este registro DNS:",
      "RECORD_TYPE": "Tipo",
      "RECORD_HOST": "Nombre",
      "RECORD_VALUE": "Valor",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Falta el registro SPF",
          "DESCRIPTION": "El dominio no indica qué servidores pueden enviar su correo. Por eso, muchos servidores de correo tratan sus respuestas como spam. Añada un registro SPF que permita {sender}."
        },
        "spf_multiple": {
          "TITLE": "El dominio tiene {count} registros SPF",
          "DESCRIPTION": "Un dominio solo puede tener un registro SPF. Si hay más, los servidores receptores ignoran SPF y a menudo rechazan el correo. Combínelos en un único registro."
        },
        "spf_not_authorized": {
          "TITLE": "SPF no permite el servidor que envía sus respuestas",
          "DESCRIPTION": "Sus respuestas se envían a través de {sender}, pero el registro SPF del dominio no lo incluye. Registro actual: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "El registro SPF necesita demasiadas consultas DNS",
          "DESCRIPTION": "Los servidores receptores dejan de comprobar SPF tras {limit} consultas DNS, pero a {sender}, que envía sus respuestas, solo se llega tras {lookups}. Sus respuestas no superan SPF. Mueva {sender} al principio del registro y elimine los include que el dominio ya no utiliza."
        },
        "spf_lookups_others": {
          "TITLE": "Algunos remitentes del registro SPF superan el límite de consultas",
          "DESCRIPTION": "El registro SPF necesita {lookups} consultas DNS y los servidores receptores se detienen tras {limit}. Sus respuestas se comprueban a tiempo y pasan, pero el correo de estos remitentes no supera SPF: {senders}. Elimine los include que el dominio ya no utiliza."
        },
        "spf_malformed": {
          "TITLE": "El registro SPF está mal formado",
          "DESCRIPTION": "Los servidores receptores no pueden leer el registro SPF del dominio, por lo que no protege sus respuestas. El problema está en: {terms}. Sustituya el registro por el corregido."
        },
        "dkim_missing": {
          "TITLE": "La firma DKIM no está configurada",
          "DESCRIPTION": "No hemos encontrado ninguna clave DKIM en {selectors}. Sin ella, sus respuestas no van firmadas y es más probable que acaben en spam. Active la firma DKIM del dominio con su proveedor de correo."
        },
        "dmarc_missing": {
          "TITLE": "Falta el registro DMARC",
          "DESCRIPTION": "Los grandes proveedores de correo, como Gmail y Microsoft, esperan un registro DMARC. Sin él, es más probable que sus respuestas acaben en spam."
        },
        "dmarc_fails": {
          "TITLE": "DMARC indica a los receptores que rechacen sus respuestas",
          "DESCRIPTION": "La política DMARC del dominio es «{policy}» y sus respuestas no superan ni SPF ni DKIM, por lo que los receptores las rechazan o las envían a spam. Corrija SPF y DKIM más arriba."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC bloquea las respuestas enviadas a través de nuestros servidores de correo",
          "DESCRIPTION": "Esta bandeja envía las respuestas a través de nuestros servidores de correo, pero la política DMARC del dominio es «{policy}», por lo que los receptores las rechazan o las envían a spam. Configure el SMTP de su propio servidor de correo para esta bandeja."
        },
        "mx_missing": {
          "TITLE": "El dominio no tiene registro MX",
          "DESCRIPTION": "Sin un registro MX nadie puede enviar correo al dominio, por lo que sus clientes no pueden responder a sus mensajes."
        }
      }
    },
    "NOTE": "Nota: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar del sitio web",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar eliminado correctamente",
              "ERROR_MESSAGE": "Hubo un error, por favor inténtelo de nuevo"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Nombre del sitio web",
          "PLACE_HOLDER": "Introduzca el nombre de su sitio web (por ejemplo: Acme Inc)",
          "ERROR": "Por favor ingrese un nombre de sitio web válido"
        },
        "WELCOME_HEADING": {
          "LABEL": "Cabecera de bienvenida",
          "PLACE_HOLDER": "¡Hola!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Bienvenido Tagline",
          "PLACE_HOLDER": "Facilitamos la conexión con nosotros. Pídanos cualquier cosa o comparte tus comentarios."
        },
        "REPLY_TIME": {
          "LABEL": "Tiempo de respuesta",
          "IN_A_FEW_MINUTES": "En algunos minutos",
          "IN_A_FEW_HOURS": "En unas horas",
          "IN_A_DAY": "En un día"
        },
        "WIDGET_COLOR_LABEL": "Color del widget",
        "WIDGET_BUBBLE_POSITION_LABEL": "Posición de Bubble del Widget",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Altura máxima de los mensajes no leídos (px)",
          "PLACE_HOLDER": "Sin límite",
          "HELP_TEXT": "Limita la altura máxima de la ventana de mensajes no leídos en píxeles. Déjalo vacío para el comportamiento predeterminado (sin límite)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Tipo de Burbuja de Widget",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Chatea con nosotros",
          "LABEL": "Título del lanzador Bubble de Widget",
          "PLACE_HOLDER": "Chatea con nosotros"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Actualizar ajustes de Widget",
          "API": {
            "SUCCESS_MESSAGE": "Configuración de Widget actualizada correctamente",
            "ERROR_MESSAGE": "No se puede actualizar la configuración del widget"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Previsualizar",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Izquierda",
          "RIGHT": "Derecha"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Estándar",
          "EXPANDED_BUBBLE": "Burbuja expandida"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Predeterminado",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Normalmente responde en unos minutos",
        "IN_A_FEW_HOURS": "Normalmente responde en unas pocas horas",
        "IN_A_DAY": "Normalmente responde en un día"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Iniciar conversación",
        "CHAT_INPUT_PLACEHOLDER": "Escribe tu mensaje"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Estamos en línea",
          "OFFLINE": "Estamos ausentes en este momento"
        },
        "USER_MESSAGE": "Hola",
        "AGENT_MESSAGE": "Hola"
      },
      "BRANDING_TEXT": "Desarrollado por JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Otros proveedores"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Sitio web",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "E-mail",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Canal API",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "PHONE": "Teléfono SIP",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    },
    "SLA": {
      "TITLE": "Políticas SLA",
      "SUB_TEXT": "Configura los tiempos de respuesta y resolución SLA para cada nivel de prioridad de la conversación.",
      "LOADING": "Cargando políticas SLA...",
      "FIELDS": {
        "ACTIVE": "Activo",
        "TICKET_PRIORITY": "Prioridad del ticket",
        "FIRST_RESPONSE_TIME": "Tiempo de primera respuesta",
        "EVERY_RESPONSE_TIME": "Tiempo de cada respuesta",
        "RESOLUTION_TIME": "Tiempo de resolución",
        "PLACEHOLDER": "p. ej. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "Políticas SLA actualizadas correctamente.",
        "ERROR_MESSAGE": "No se pudieron actualizar las políticas SLA. Por favor, inténtalo de nuevo."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Prioridad automática",
      "SUB_TEXT": "Configura la asignación automática de prioridad según el contenido de la conversación.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Aviso de facturación",
        "MESSAGE": "Cada evaluación de prioridad incurrirá en un cargo. Por favor, revisa los detalles de tu plan para información sobre precios."
      },
      "MODE": {
        "OFF": "Desactivado",
        "ALL_MESSAGES": "Activado para todos los mensajes entrantes",
        "FIRST_MESSAGE": "Activado solo para el primer mensaje entrante"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Configuración de niveles de prioridad",
        "SUB_TEXT": "Configura qué niveles de prioridad deben estar habilitados y sus descripciones. Proporciona criterios claros para que la IA determine cuándo asignar esta prioridad."
      },
      "DESCRIPTION_LABEL": "Descripción",
      "DESCRIPTION_PLACEHOLDER": "Describe las conversaciones que deben marcarse con prioridad {priority}",
      "SET_AS_DEFAULT": "Establecer como prioridad predeterminada",
      "MULTIPLE_DEFAULTS_WARNING": "Solo un nivel de prioridad debe establecerse como predeterminado. Por favor, desmarca otros predeterminados."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Etiquetado automático",
      "SUB_TEXT": "Configura la asignación automática de etiquetas según el contenido de la conversación.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Aviso de facturación",
        "MESSAGE": "Cada evaluación de etiquetado incurrirá en un cargo. Por favor, revisa los detalles de tu plan para información sobre precios."
      },
      "MODE": {
        "OFF": "Desactivado",
        "CONVERSATION_OPEN": "Al abrir la conversación",
        "CONVERSATION_CLOSE": "Al cerrar la conversación",
        "ALL_MESSAGES": "En cada mensaje - independientemente del estado",
        "FIRST_MESSAGE": "En el primer mensaje - independientemente del estado"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Configuración de etiquetas",
        "SUB_TEXT": "Configura qué etiquetas deben estar disponibles para asignación automática y sus descripciones. Proporciona criterios claros para que la IA determine cuándo aplicar esta etiqueta."
      },
      "DESCRIPTION_LABEL": "Descripción",
      "DESCRIPTION_PLACEHOLDER": "Describe las conversaciones que deben etiquetarse como {label}. Si lo dejas vacío, se usará la descripción de la etiqueta.",
      "NO_LABELS_MESSAGE": "No se encontraron etiquetas. Crea etiquetas primero para habilitar el etiquetado automático.",
      "CREATE_LABELS_LINK": "Crear etiquetas"
    },
    "PHONE": {
      "TITLE": "Configuración del teléfono",
      "SUBTITLE": "Configura qué llamadas se mostrarán en esta bandeja de entrada.",
      "UPDATE": "Guardar configuración",
      "EDIT": {
        "SUCCESS_MESSAGE": "Configuración del teléfono actualizada",
        "ERROR_MESSAGE": "Error al actualizar la configuración del teléfono"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Números de teléfono",
        "SUBTITLE": "Introduce los números de teléfono que pertenecen a esta bandeja de entrada.",
        "PLACEHOLDER": "+145123908635",
        "ADD": "Añadir un número de teléfono"
      }
    }
  }
}
